// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"styles_selectWrapper__yA7LQ","select":"styles_select__3r7bx"};